/**
 *  sessionStorage管理
 *  
 */
import {AesUtil} from './AESUtils'
// 新增一个session键值对
function insertSessionStorage(key, value){
  let a = window.sessionStorage[key]
  if(a){
    // console.log("该session已存在, 值为:{" + key + " ," + a + "}")
  }
  sessionStorage.setItem(key, AesUtil.getAxiosJSONstr(value).text);
}

// 依据key值删除指定的session
function delSessionStorage(key) {
  let a = window.sessionStorage[key]
  if(a){
    sessionStorage.removeItem(key);
  }else{
    console.error("该session不存在, 您要删除的session的key值为：" + key)
  }
}

// 修改session
function updataSession(key, value){
  let a = window.sessionStorage[key]
  if(a){
    sessionStorage[key] = AesUtil.getAxiosJSONstr(a).text
  }else{
    console.error("该session不存在, 您要修改的session值为：{" + key + ", " + value + "}")
  }
}

// 查询session
function selectSession(key){
  let a = window.sessionStorage[key]
  if(a){
    return AesUtil.getAxiosHeadJSONstr(a)
  }else{
    console.log("该session不存在, 您要查询session的key值为：" + key)
    return undefined
  }
}
// 清理所有的session
function delAllSession(){
  let a = window.sessionStorage
  if(a.length > 0){
    Object.keys(a).forEach(item => {
      console.log(item) 
      sessionStorage.removeItem(item)
    })
  }
}

export const sessionSto = {
  $insertSessionStorage: (key, value) => insertSessionStorage(key, value),
  $delSessionStorage: (key) => delSessionStorage(key),
  $updataSession: (key, value) => updataSession(key, value),
  $selectSession: (key) => selectSession(key),
  $delAllSession: () => delAllSession()
}

export default {
  install: function (Vue) {
    Vue.prototype.$insertSessionStorage = (key, value) => insertSessionStorage(key, value)
    Vue.prototype.$delSessionStorage = (key) => delSessionStorage(key)
    Vue.prototype.$updataSession = (key, value) => updataSession(key, value)
    Vue.prototype.$selectSession = (key) => selectSession(key)
    Vue.prototype.$delAllSession = () => delAllSession()
  }
}


























// WEBPACK FOOTER //
// ./src/util/sessionStorageManage.js